var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyalty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2715,
    cy: 40.7925,
    r: 39.5337,
    fill: "#FFA831",
    stroke: "#EE8F0F",
    strokeWidth: 0.722585
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5029,
    cy: 41.0234,
    r: 34.5468,
    fill: "url(#paint0_linear_1773_14052)",
    stroke: "#FDBD4D",
    strokeWidth: 0.722585
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1773_14052)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5027 15.4258C37.1392 15.4304 33.809 16.0912 30.6987 17.3712C27.6013 18.6511 24.7856 20.5454 22.405 22.926C17.5926 27.7128 14.9048 34.2402 14.9048 41.0237C14.9019 44.3855 15.5629 47.7148 16.85 50.8205C18.1371 53.9262 20.0249 56.7471 22.405 59.1214C24.7772 61.5006 27.5956 63.3882 30.6987 64.6761C33.809 65.9561 37.1392 66.617 40.5027 66.6216C43.8645 66.6245 47.1938 65.9634 50.2995 64.6763C53.4052 63.3892 56.2261 61.5015 58.6004 59.1214C63.4128 54.3346 66.1006 47.8071 66.1006 41.0237C66.1006 37.6703 65.435 34.3426 64.1551 31.2197C62.8752 28.1223 60.981 25.3066 58.6004 22.926C56.2198 20.5454 53.404 18.6511 50.3067 17.3712C47.1837 16.0913 43.856 15.4258 40.5027 15.4258ZM23.3281 51.2263L39.2748 25.0918V35.9561C36.9996 44.207 27.6957 49.5741 23.3281 51.2263ZM35.6299 45.5187L40.5026 38.8136L45.3753 45.5187H35.6299ZM34.9686 47.3215L26.335 52.4783H54.6702L46.0366 47.3215H34.9686ZM57.6771 51.2263L41.7304 25.0918V35.9561C44.0056 44.207 53.3095 49.5741 57.6771 51.2263Z",
    fill: "#FDE194"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1773_14052",
    x: 11.1646,
    y: 12.9323,
    width: 58.6761,
    height: 58.6761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.24672
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.87008
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1773_14052"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24672
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.039 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1773_14052",
    result: "effect2_dropShadow_1773_14052"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1773_14052",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1773_14052",
    x1: 68.8657,
    y1: 60.6592,
    x2: 9.33488,
    y2: 26.0627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493004,
    stopColor: "#F8AA1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978599,
    stopColor: "#FEC258"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/Loyalty.017d74e4d6c16e4fd9d0223a5a39944a.svg";
export { ForwardRef as ReactComponent };